import React from 'react';
import { TAppRoutes } from '../../app/features/routes/types/TAppRoute';
import HomeIntroPage from './pages/HomeIntroPage';

const HomeRoutes = {
	index: {
		tag: 'intro',
		path: '/intro',
		auth: false,
		component: <HomeIntroPage />,
	},
} as TAppRoutes;

export default HomeRoutes;
